<template>
  <div style="background-color: #172b4d;">
    <!-- Header -->
    <div class="header bg-gradient-success py-7 py-lg-8 pt-lg-9">
      <b-container>
        <div class="header-body text-center mb-7">
          <b-row class="justify-content-center">
            <b-col xl="5" lg="6" md="8" class="px-5">
              <h1 class="text-white">
                Pricing plans that grow as your business grows.
              </h1>
            </b-col>
          </b-row>
        </div>
      </b-container>
      <div class="separator separator-bottom separator-skew zindex-100">
        <svg
          x="0"
          y="0"
          viewBox="0 0 2560 100"
          preserveAspectRatio="none"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
        >
          <polygon
            class="fill-default"
            points="2560 0 2560 100 0 100"
          ></polygon>
        </svg>
      </div>
    </div>
    <!-- Page content -->
    <b-container class="mt--8 pb-5">
      <b-row class="justify-content-center">
        <b-col lg="10">
          <b-card-group class="pricing flex-column flex-md-row mb-3">
            <card
              header-classes="bg-transparent"
              body-classes="px-lg-7"
              class="card-pricing border-0 text-center mb-4"
            >
              <h4
                slot="header"
                class="text-uppercase ls-1 text-primary py-3 mb-0"
              >
                Starter
              </h4>

              <div class="display-2">$5</div>
              <span class="text-muted">/month</span>
              <ul class="list-unstyled my-4">
                <li>
                  <div class="d-flex align-items-center">
                    <div>
                      <div
                        class="icon icon-xs icon-shape bg-gradient-primary shadow rounded-circle text-white"
                      >
                        <i class="fas fa-database"></i>
                      </div>
                    </div>
                    <div>
                      <span
                        class="ml-2 helptext"
                        v-b-tooltip.hover.right
                        title="Monitor 8 of your own websites and APIs (or third-party APIs you depend on)."
                      >
                        8 components monitored
                      </span>
                    </div>
                  </div>
                </li>
                <li>
                  <div class="d-flex align-items-center">
                    <div>
                      <div
                        class="icon icon-xs icon-shape bg-gradient-primary shadow rounded-circle text-white"
                      >
                        <i class="fas fa-sync-alt"></i>
                      </div>
                    </div>
                    <div>
                      <span
                        class="ml-2 helptext"
                        v-b-tooltip.hover.right
                        title="All components you monitor get pinged every 5 minutes."
                      >
                        Updates every 5 minutes
                      </span>
                    </div>
                  </div>
                </li>
                <li>
                  <div class="d-flex align-items-center">
                    <div>
                      <div
                        class="icon icon-xs icon-shape bg-gradient-primary shadow rounded-circle text-white"
                      >
                        <i class="fas fa-user"></i>
                      </div>
                    </div>
                    <div>
                      <span
                        class="ml-2 helptext"
                        v-b-tooltip.hover.right
                        title="Display your status page publicly."
                      >
                        Private status page
                      </span>
                    </div>
                  </div>
                </li>
                <li>
                  <div class="d-flex align-items-center">
                    <div>
                      <div
                        class="icon icon-xs icon-shape bg-gradient-primary shadow rounded-circle text-white"
                      >
                        <i class="fas fa-envelope"></i>
                      </div>
                    </div>
                    <div>
                      <span
                        class="ml-2 helptext"
                        v-b-tooltip.hover.right
                        title="Let your customers subscribe to your status page and get notified when downtime happens."
                      >
                        500 subscribers
                      </span>
                    </div>
                  </div>
                </li>
              </ul>

              <payment ref="payment">
                <template v-slot:paymentbtn>
                  <base-button
                    @click="startCheckoutFlow"
                    type="primary"
                    class="mb-3"
                  >
                    Start Free Trial
                  </base-button>
                </template>
              </payment>

              <span slot="footer" class="text-light">
                14 day free trial. Cancel any time.
              </span>
            </card>

            <card
              gradient="info"
              class="card-pricing zoom-in shadow-lg rounded border-0 text-center mb-4"
              header-classes="bg-transparent"
              body-classes="px-lg-7"
              footer-classes="bg-transparent"
            >
              <h4
                slot="header"
                class="text-uppercase ls-1 text-white py-3 mb-0"
              >
                Business
              </h4>

              <div class="display-1 text-white">Coming Soon</div>
              <!--
              <span class="text-white">per month</span>
              -->
              <ul class="list-unstyled my-4">
                <li>
                  <div class="d-flex align-items-center">
                    <div>
                      <div
                        class="icon icon-xs icon-shape bg-white shadow rounded-circle text-muted"
                      >
                        <i class="fas fa-terminal"></i>
                      </div>
                    </div>
                    <div>
                      <span class="pl-2 text-white">∞ monitors</span>
                    </div>
                  </div>
                </li>
                <li>
                  <div class="d-flex align-items-center">
                    <div>
                      <div
                        class="icon icon-xs icon-shape bg-white shadow rounded-circle text-muted"
                      >
                        <i class="fas fa-pen-fancy"></i>
                      </div>
                    </div>
                    <div>
                      <span class="pl-2 text-white">
                        Multiple, private status pages
                      </span>
                    </div>
                  </div>
                </li>
                <li>
                  <div class="d-flex align-items-center">
                    <div>
                      <div
                        class="icon icon-xs icon-shape bg-white shadow rounded-circle text-muted"
                      >
                        <i class="fas fa-hdd"></i>
                      </div>
                    </div>
                    <div>
                      <span class="pl-2 text-white">10,000 subscribers</span>
                    </div>
                  </div>
                </li>
              </ul>

              <base-button disabled type="secondary" class="mb-3">
                Coming Soon
              </base-button>

              <a
                slot="footer"
                href="mailto:hello@boltscale.io"
                class="text-white"
              >
                Contact us for more info
              </a>
            </card>
          </b-card-group>
        </b-col>
      </b-row>
      <div class="d-flex justify-content-lg-center px-3 mt-5">
        <div>
          <div
            class="icon icon-shape bg-gradient-white shadow rounded-circle text-primary"
          >
            <i class="ni ni-building text-primary"></i>
          </div>
        </div>
        <b-col lg="6">
          <p class="text-white">
            <strong>
              Or,
              <router-link to="/register">
                monitor 3 components for free.
              </router-link>
            </strong>
            Upgrade any time.
          </p>
        </b-col>
      </div>
      <b-row class="row-grid justify-content-center">
        <b-col lg="10">
          <div class="table-responsive">
            <base-table class="table table-dark mt-5" :data="features">
              <template slot="columns">
                <th class="bg-transparent" scope="col">
                  <span class="text-light font-weight-700">Features</span>
                </th>
                <th class="text-center bg-transparent" scope="col">Free</th>
                <th class="text-center bg-transparent" scope="col">Starter</th>
                <th class="text-center bg-transparent" scope="col">Business</th>
              </template>

              <template slot-scope="{ row }">
                <td class="">
                  {{ row.title }}
                  <i
                    class="fa fa-question-circle"
                    aria-hidden="true"
                    v-b-tooltip.hover.top
                    v-if="row.tooltip"
                    :title="row.tooltip"
                  ></i>
                </td>
                <td class="text-center" v-html="row.free"></td>
                <td class="text-center" v-html="row.starter"></td>
                <td class="text-center" v-html="row.business"></td>
              </template>
            </base-table>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import BaseTable from "@/components/BaseTable";
import Payment from "@/components/Payment";
export default {
  name: "pricing-page",
  components: {
    BaseTable,
    Payment
  },
  methods: {
    startCheckoutFlow() {
      this.$gtag.event("begin_checkout");
      this.$analytics.fbq.event("InitiateCheckout");
      this.$refs.payment.checkout();
    }
  },
  data() {
    return {
      features: [
        {
          title: "Ping frequency",
          free: '<span class="text-sm text-light">Every 30 minutes</span>',
          starter: '<span class="text-sm text-light">Every 5 minutes</span>',
          business: '<span class="text-sm text-light">Every 1 minute</span>'
        },
        {
          title: "Number of components monitored",
          tooltip: "A 'component' is an API or website that is monitored.",
          free: '<span class="text-sm text-light">3</span>',
          starter: '<span class="text-sm text-light">8</span>',
          business: '<span class="text-sm text-light">∞</span>'
        },
        {
          title: "Slack notifications",
          free: '<i class="fas fa-check text-success"></i>',
          starter: '<i class="fas fa-check text-success"></i>',
          business: '<i class="fas fa-check text-success"></i>'
        },
        {
          title: "Email notifications",
          free: '<i class="fas fa-check text-success"></i>',
          starter: '<i class="fas fa-check text-success"></i>',
          business: '<i class="fas fa-check text-success"></i>'
        },
        {
          title: "SMS notifications",
          free: "-",
          starter: "-",
          business: '<i class="fas fa-check text-success"></i>'
        },
        {
          title: "Public status pages",
          free: '<i class="fas fa-check text-success"></i>',
          business: '<i class="fas fa-check text-success"></i>',
          starter: '<i class="fas fa-check text-success"></i>'
        },
        {
          title: "Private status pages",
          free: "-",
          business: '<i class="fas fa-check text-success"></i>',
          starter: '<i class="fas fa-check text-success"></i>'
        },
        {
          title: "Subscribers",
          tooltip:
            "Let your customers subscribe to your status page. They'll get notified whenever downtime happens.",
          free: "-",
          business: "10,000",
          starter: "500"
        },
        {
          title: "Per-component notifications",
          tooltip:
            "Subscribe to individual components, like GitHub or Digital Ocean.",
          free: "-",
          starter: '<i class="fas fa-check text-success"></i>',
          business: '<i class="fas fa-check text-success"></i>'
        },
        {
          title: "Basic customization",
          free: '<i class="fas fa-check text-success"></i>',
          business: '<i class="fas fa-check text-success"></i>',
          starter: '<i class="fas fa-check text-success"></i>'
        },
        {
          title: "Advanced customization",
          free: "-",
          business: '<i class="fas fa-check text-success"></i>',
          starter: '<i class="fas fa-check text-success"></i>'
        },
        {
          title: "Custom CSS",
          free: "-",
          starter: "-",
          business: '<i class="fas fa-check text-success"></i>'
        }
      ]
    };
  },
  mounted() {
    this.$gtag.event("generate_lead");
    this.$analytics.fbq.event("Lead");
  }
};
</script>
<style>
.helptext {
  border-bottom: 2px dotted #ddd;
  cursor: help;
}
</style>
